import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    Table as Table2
} from '@devexpress/dx-react-grid-material-ui';

const tableStyles = () => ({
    table: {
        overflow: 'hidden !important'
    }
});

const TableComponentBase = ({ classes, ...restProps }) => (
    <Table2.Table
        {...restProps}
        className={classes.table}
    />
);

export const TableComponent = withStyles(tableStyles, { name: 'TableComponent' })(TableComponentBase);




// WEBPACK FOOTER //
// ./src/main/content/data-groups/TableComponent.js